import { Box, Button, Grid, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";
// import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { setWordCase } from "../../../assets/library";
import { useAppDispatch, useAppSelector } from "../../../assets/hooks";
import EditIcon from '@mui/icons-material/Edit';
import ConfirmDialog from "../../../components/confirmDialog";
import { Event } from "../../../types/types";
import { setPopup } from "../../../store/slices/popupSlice";
import { InfoOutlined } from "@mui/icons-material";

const SuggestedPackages = (props: any) => {
  // console.log(props,"id")
  const suggestedPackages = useAppSelector(store => store.suggestedPackages)
  // console.log(suggestedPackages)
  const [open, setOpen] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const eventHandler = async (event: Event) => {
    switch (event.name) {
      case "delete":
        try {
        } catch (error) { }
        setOpen(false);
        break;

      default:
        break;
    }
  };
  return (
    <div>
      <Typography
        sx={{
          background: "#FCF1EE",
          width: "fit-content",
          p: 1,
          borderRadius: "10px",
          mb: 2,
        }}
      >
        Suggested Packages
      </Typography>
      <Grid container spacing={2}>
        {
          suggestedPackages?.data?.map((item: any, i: number) => (
            <Grid item xs={12} sm={6} md={4} sx={{ textWrap: "wrap", }} key={i}>
              <Box sx={{
                background: "#D1D3F933", borderRadius: "15px", p: 2, position: "relative", minHeight: "350px", maxHeight: "400px", overflowY: "scroll", height: "100%",
                "&::-webkit-scrollbar": {
                  width: "5px",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#e8e1e1",
                  borderRadius: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  // backgroundColor: "#e8e1e1",
                },
              }} >
                <Box sx={{ display: "flex", justifyContent: "end", alignItems: "end", mt: 1 }}>
                  {/* <DeleteOutlineOutlinedIcon sx={{fontSize:"1rem"}} onClick={()=>setOpen(true)}/> */}
                  <EditIcon sx={{ fontSize: "1rem" }} onClick={() =>
                    dispatch(
                      setPopup({
                        show: true,
                        data: {
                          container: {
                            name: "suggested",
                            data: {
                              id: props?.id,
                              editMode: true,
                              package: item
                            },

                            dimensions: {
                              width: "60%",
                            },
                          },
                          type: "custom",
                        },
                      }))
                  } />
                </Box>
                <Typography sx={{ position: "relative", width: "1.5rem", height: "1.5rem", borderRadius: "50%", background: "#9CFFF9" }}>
                  <Typography sx={{ position: "absolute", top: "-4px", left: "14px", width: "200px", color: "#000" }} fontWeight="500" fontSize="1rem">
                    {item?.name}
                  </Typography>
                </Typography>
                {item?.priceDetails?.totalPrice === 0 ?
                  <Button
                    sx={{
                      width: '50px',
                      color: "#000",
                      background: 'linear-gradient(90deg, #1976d2 0%, #b667c1 100%)',
                      fontWeight: '500',
                      fontSize: '11px',
                      textTransform: 'none',
                      borderRadius: '15px',
                      padding: '0',
                      position: "absolute",
                      top: 0,
                      right: 0,
                    }}
                  >
                    Free
                  </Button> : ""}

                <ul style={{
                  listStyleType: 'disc',
                  color: "#000",
                  padding: "14px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                  fontSize: "13px",
                  height: "120px",
                  marginTop: "1rem"
                }}>
                  <li>{item?.country?.length} Countries ({item?.country?.map((i: string) => i + " / ")}) </li>
                  <li>Total Price : {item?.priceDetails?.totalPrice ? item?.priceDetails?.currency?.symbol + item?.priceDetails?.totalPrice : item?.priceDetails?.totalPrice}</li>
                  {
                    item?.products?.map((product: any) => (
                      <li>{setWordCase(product?.category)} : {product?.quantity}</li>
                    ))
                  }

                </ul>
                <Typography sx={{
                  color: "#000",
                }}>Benefits</Typography>
                <ul style={{
                  listStyleType: 'disc',
                  color: "#000",
                  padding: "0 14px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                  fontSize: "13px",
                  // height:"190px",
                  marginTop: "1rem",
                  // overflowY:"scroll"
                }}>
                  {
                    item?.benefits?.map((product: any) => (
                      <li>{product}</li>
                    ))
                  }

                </ul>
                {
                  item?.requirements?.length > 0 ?
                    <>
                      <Typography sx={{
                        color: "#000",
                      }}>Requirements</Typography>
                      <ul style={{
                        listStyleType: 'disc',
                        color: "#000",
                        padding: "0 14px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "0.5rem",
                        fontSize: "13px",
                        // height:"190px",
                        marginTop: "1rem",
                        // overflowY:"scroll"
                      }}>
                        {
                          item?.requirements?.map((product: any) => (
                            <li>{product}</li>
                          ))
                        }

                      </ul>
                    </> : ""
                }
                <Box sx={{float:"right"}}>
                <Tooltip
                  title={
                    item?.termsAndConditions ? (
                      <Typography sx={{ fontSize: "12px" }}>
                        {item?.termsAndConditions}
                      </Typography>
                    ) : (
                      ""
                    )
                  }
                  arrow
                >
                  <InfoOutlined sx={{fontSize:"1.25rem",cursor:"pointer"}}/>
                </Tooltip>
                </Box>
                
                {/* <Link sx={{
                  textDecoration: "none",
                  color:selectedPackage === item._id ?"#fff":"#000",
                  fontSize: "14px",
                  display: "flex",
                  gap: "0.5rem",
                  justifyContent: "end",
                  alignItems: "center"
                }}>
                  View details
                  <ArrowRightAltIcon sx={{ color:selectedPackage === item._id ?"#fff":"#000",}} />
                </Link> */}
              </Box>
            </Grid>
          ))
        }
      </Grid>
      <ConfirmDialog
        open={open}
        handleClose={() => setOpen(false)}
        additionalData={{
          onSubmit: () => eventHandler({ name: "delete", data: "" }),
          title: "Are you sure you want to delete package?",
          content: "",
        }}
      />
    </div>
  );
};

export default SuggestedPackages;
